import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTime = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(24 24) rotate(180)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "a",
				d: "M0,0H24V24H0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M10,18h4"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M16.979,3H7.021a1,1,0,0,0-1,1V6.378A2,2,0,0,0,6.4,7.551L9.621,12,6.4,16.449a2,2,0,0,0-.38,1.173V20a1,1,0,0,0,1,1h9.957a1,1,0,0,0,1-1V17.658a2,2,0,0,0-.42-1.226L14.121,12l3.438-4.433a2,2,0,0,0,.42-1.226V4a1,1,0,0,0-1-1Z"
			})
		]
	})]
});
export default SvgTime;
